import { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";
import { CrownMark } from "./CrownMark";

const links = [
  { label: "Our Story", href: "#story", testId: "nav-story-link" },
  { label: "Specialities", href: "#specialities", testId: "nav-specialities-link" },
  { label: "Menu", href: "#menu", testId: "nav-menu-link" },
  { label: "Find Us", href: "#visit", testId: "nav-visit-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled || open ? "border-b border-gold/15 bg-onyx/85 backdrop-blur-xl" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2.5" data-testid="site-logo" onClick={() => setOpen(false)}>
          <CrownMark size={26} />
          <span className="whitespace-nowrap font-display text-lg tracking-wide text-cream">
            The Royal <span className="italic text-gold">Cafe</span>
          </span>
        </a>
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Main navigation">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className="whitespace-nowrap font-mono text-[0.68rem] uppercase tracking-[0.25em] text-ash transition-colors duration-300 hover:text-gold-light"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+917358403972"
            data-testid="nav-call-link"
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-gold/40 px-4 py-2 font-mono text-[0.68rem] uppercase tracking-[0.2em] text-gold-light transition-colors duration-300 hover:bg-gold hover:text-onyx"
          >
            <Phone size={13} /> 73584 03972
          </a>
        </nav>
        <button
          className="text-cream lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
          data-testid="mobile-menu-button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-gold/10 bg-onyx/95 px-5 py-6 backdrop-blur-xl lg:hidden" aria-label="Mobile navigation">
          <div className="flex flex-col gap-5">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-${link.testId}`}
                onClick={() => setOpen(false)}
                className="font-display text-2xl italic text-cream transition-colors hover:text-gold-light"
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+917358403972"
              data-testid="mobile-nav-call-link"
              className="mt-2 flex w-max items-center gap-2 rounded-full border border-gold/40 px-5 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-gold-light"
            >
              <Phone size={14} /> Call us
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
